import { LegalClientLegalAddressEntity } from 'api/types/entity';
import { parseAddressValue } from 'modules/client/common/helpers';
import { Maybe } from 'types/maybe';

import { CompanyRegistrationAddressFormType } from '../../forms/companyRegistrationAddressForm';

export const parseLegalAddressValue = (
  address?: Maybe<LegalClientLegalAddressEntity>
): CompanyRegistrationAddressFormType['companyRegistrationAddress'] => ({
  ...parseAddressValue(address),
  confirmationFiles: address?.confirmationFiles,
});
